import { format } from 'date-fns';

export class Todo {
    want: string;
    why: string;
    difficulty: string;
    hope: string;
    period: string;
    challenge: string;
    color: string;
    date: Date;
    achievement: number;
    x: number;
    y: number;
    completiondate?: string;
    key?: string;
    index?: string;

    constructor(values: any) {
        this.want = values.want;
        this.why = values.why;
        this.difficulty = values.difficulty;
        this.hope = values.hope;
        this.period = values.period;
        this.challenge = values.challenge;
        this.achievement = values.achievement;
        this.color = values.color
        this.date = values.date || format(new Date());
        if (values.x) { this.x = values.x } else{ this.x = 0 }
        if (values.y) { this.y = values.y } else{ this.y = 0 }
        if (values.key) { this.key = values.key }
        if (values.index) { this.index = values.index } 
    }
}



// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/yarukami/src/app/class/todo.ts